<template>
  <div class="home">
    <div v-if="scanMode" class="scan">
      <div class="top">
        <button class="secondary" type="button" @click="scanTurnOff">Zpět</button>
      </div>
      <div class="area">
        <qrcode-stream :track="paintBoundingBox" @decode="onDecode" @error="onError"/>
      </div>
      <div class="bottom">
        <div class="result">
          <p>Rozpoznávám:</p>
          <p>{{result}}</p>
        </div>
        <div class="btn">
          <button type="button" @click="confirmScan">Potvrdit zadání</button>
        </div>
      </div>
    </div>
    <form v-on:submit.prevent="checkSubmit" class="form" v-if="!scanMode">
      <div class="row">
        <label for="idUnit">ID jednotky (IMEI nebo sériové číslo)</label>
        <input
          type="number"
          inputmode="numeric"
          pattern="[0-9]*"
          id="idUnit"
          name="idUnit"
          tabindex="1"
          v-model="idUnit"
          required
          autocomplete="off"
        />
      </div>
      <div class="row btns">
        <button class="secondary" type="button" @click="scanTurnOn">Skenovat</button>
        <button type="submit" tabindex="3">Pokračovat</button>
      </div>
      <div class="row" v-if="info">
        <p class="error" v-html="info"></p>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "../store";
import sendMessage from "../utils/functions";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';
import BackIcon from "@/icons/BackIcon.vue";

export default {
  name: "Home",
  mounted() {
    document.title = "GPS Dozor Servis";
    //this.checkLogin();
    sendMessage(`state:finished`);
    if (this.$route.query.mob === "true") {
      this.mob = true;
    }
    if (this.$route.query.code) {
      this.idUnit = this.$route.query.code;
    }
    if (store.state.role == 2) {
      this.$router.push("history");
      return;
    }
  },
  components: {
    BackIcon,
    QrcodeStream
  },
  computed: {
    role() {
      return store.state.role;
    }
  },
  watch: {
    role: function(newRole) {
      if (newRole == 2) {
        this.$router.push("history");
        return;
      }
    }
  },
  data: function() {
    return {
      idUnit: null,
      info: null,
      mob: false,
      code: null,
      result: "-",
      error: null,
      scanMode: false
    };
  },
  methods: {
    checkSubmit: async function() {
      store.commit("showLoading");
      const result = await store.dispatch("check", { idUnit: this.idUnit });
      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      if (result && store.state.checkResult.isInWarehouse) {
        if (this.mob) {
          sendMessage(`state:success`);
        }
        store.commit("saveState");
        this.$router.push("check");
      } else {
        this.info = "Jednotku se zadaným ID se nepodařilo najít.";
        if (this.mob) {
          sendMessage(`state:fail`);
        }
      }
    },
    paintBoundingBox: function(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: { x, y, width, height }
        } = detectedCode

        ctx.lineWidth = 4
        ctx.strokeStyle = '#03893D'
        ctx.strokeRect(x, y, width, height)
      }
    },
    onError: function (err) {
        this.error = `[${err.name}]: `

        if (err.name === 'NotAllowedError') {
          this.error += 'you need to grant camera access permission'
        } else if (err.name === 'NotFoundError') {
          this.error += 'no camera on this device'
        } else if (err.name === 'NotSupportedError') {
          this.error += 'secure context required (HTTPS, localhost)'
        } else if (err.name === 'NotReadableError') {
          this.error += 'is the camera already in use?'
        } else if (err.name === 'OverconstrainedError') {
          this.error += 'installed cameras are not suitable'
        } else if (err.name === 'StreamApiNotSupportedError') {
          this.error += 'Stream API is not supported in this browser'
        } else if (err.name === 'InsecureContextError') {
          this.error += 'Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.'
        } else {
          this.error += err.message
        }
      },
    onDecode: function (decodedString) {
      this.result = decodedString;
    },
    scanTurnOn: function(){
      this.scanMode = true;
    },
    scanTurnOff: function(){
      this.scanMode = false;
    },
    confirmScan: function(){
      this.scanMode = false;
      this.idUnit = this.result;
    }
  }
};
</script>
